import { useNavigate } from 'react-router-dom';
import { Document } from '@/db';
import { DocumentIcon } from '@heroicons/react/24/outline';

interface PdfLinkProps {
  doc: Document;
  clientSlug: string;
  disabled?: boolean;
}

export default function PdfLink({ doc, clientSlug, disabled = false }: PdfLinkProps) {
  const navigate = useNavigate();

  const className = disabled
    ? 'text-blue-600 p-2 -m-0.5 rounded-lg opacity-50 cursor-not-allowed'
    : 'text-blue-600 hover:text-blue-800 p-2 -m-0.5 rounded-lg hover:bg-blue-50 transition-colors';

  return (
    <button
      className={className}
      title={disabled ? 'PDF not available offline' : 'View as PDF'}
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        if (disabled) return;

        // Determine route based on document type
        const isDraft = typeof doc.id === 'string' && doc.id.startsWith('draft-');
        const route = isDraft
          ? `/clients/${clientSlug}/documents/drafts/${doc.id}/pdf`
          : `/clients/${clientSlug}/documents/${doc.id}/pdf`;

        // Navigate to PDF page
        navigate(route);
      }}
    >
      <DocumentIcon className="h-5 w-5" />
    </button>
  );
}
